/**
 * Notice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UrlObject model module.
 * @module model/UrlObject
 * @version 1.0
 */
class UrlObject {
    /**
     * Constructs a new <code>UrlObject</code>.
     * @alias module:model/UrlObject
     */
    constructor() { 
        
        UrlObject.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UrlObject</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UrlObject} obj Optional instance to populate.
     * @return {module:model/UrlObject} The populated <code>UrlObject</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UrlObject();

            if (data.hasOwnProperty('url')) {
                obj['url'] = ApiClient.convertToType(data['url'], 'String');
            }
        }
        return obj;
    }


}

/**
 * url of the youtube link
 * @member {String} url
 */
UrlObject.prototype['url'] = undefined;






export default UrlObject;

